import { Component, OnInit } from '@angular/core';
import { UserControllerService } from 'src/app/services/user-controller.service';

@Component({
  selector: 'app-recruiter-sidenav',
  templateUrl: './recruiter-sidenav.component.html',
  styleUrls: ['./recruiter-sidenav.component.scss']
})
export class RecruiterSidenavComponent implements OnInit {

  constructor(private _recruiters: UserControllerService) { }

  recruiters;

  ngOnInit(): void {
    this._recruiters.getRecruiters().subscribe(resolve => {
      this.recruiters = resolve
    })
  }

  onSelect(id) {
    
  }

}
